import {
  staticPriceEndpoints,
  TGetPriceBaseResponse,
  IBaseUpdatePriceDTO,
  TGetAppraiserPriceResponse,
  getPricesEndpoints,
  IUpdateAppraiserPriceDTO,
  TGetPhotoShootingPriceResponse,
  IUpdatePhotoShootingPriceDTO,
  TUpdateAppraiserPriceResponse,
  TUpdatePhotoShootingPriceResponse,
  TCreatePhotoShootingPriceDTO,
  TUpdateSettlementDataResponse,
  IUpdateSettlementDataDTO,
} from '@/models/prices.model';
import { ApiResponse, httpClient } from '@/utils';

class PricesAPI {
  static getAppraisePrice(): ApiResponse<TGetAppraiserPriceResponse> {
    const { GET_APPRAISER_PRICES } = staticPriceEndpoints;
    return httpClient.get<TGetAppraiserPriceResponse>(GET_APPRAISER_PRICES);
  }

  static updateAppraisePrice(data: IUpdateAppraiserPriceDTO): ApiResponse<TUpdateAppraiserPriceResponse> {
    const { UPDATE_APPRAISER_PRICES } = staticPriceEndpoints;
    return httpClient.post<TUpdateAppraiserPriceResponse>(UPDATE_APPRAISER_PRICES, data);
  }

  static getSettlementData(): ApiResponse<TUpdateSettlementDataResponse> {
    const { GET_SETTLEMENT_PRICE } = staticPriceEndpoints;
    return httpClient.get<TUpdateSettlementDataResponse>(GET_SETTLEMENT_PRICE);
  }

  static getDocumentsPrice(): ApiResponse<TGetPriceBaseResponse> {
    const { GET_DOCUMENTS_PRICE } = staticPriceEndpoints;
    return httpClient.get<TGetPriceBaseResponse>(GET_DOCUMENTS_PRICE);
  }

  static updateDocumentsPrice(data: IBaseUpdatePriceDTO): ApiResponse<TGetPriceBaseResponse> {
    const { UPDATE_DOCUMENTS_PRICE } = staticPriceEndpoints;
    return httpClient.post<TGetPriceBaseResponse>(UPDATE_DOCUMENTS_PRICE, data);
  }

  static getPhotoShootingPrice(): ApiResponse<TGetPhotoShootingPriceResponse> {
    const { GET_PHOTO_SHOOTING_PRICES } = staticPriceEndpoints;
    return httpClient.get<TGetPhotoShootingPriceResponse>(GET_PHOTO_SHOOTING_PRICES);
  }

  static updatePhotoShootingPrice({
    id,
    ...data
  }: IUpdatePhotoShootingPriceDTO): ApiResponse<TUpdatePhotoShootingPriceResponse> {
    const { UPDATE_PHOTO_SHOOTING_PRICE } = getPricesEndpoints({ id });
    return httpClient.post<TUpdatePhotoShootingPriceResponse>(UPDATE_PHOTO_SHOOTING_PRICE, data);
  }

  static createPhotoShootingPrice(data: TCreatePhotoShootingPriceDTO): ApiResponse<TUpdatePhotoShootingPriceResponse> {
    const { CREATE_PHOTO_SHOOTING_PRICE } = staticPriceEndpoints;
    return httpClient.put<TUpdatePhotoShootingPriceResponse>(CREATE_PHOTO_SHOOTING_PRICE, data);
  }

  static deletePhotoShootingPrice(id: string): ApiResponse<TUpdatePhotoShootingPriceResponse> {
    const { DELETE_PHOTO_SHOOTING_PRICE } = getPricesEndpoints({ id });
    return httpClient.delete<TUpdatePhotoShootingPriceResponse>(DELETE_PHOTO_SHOOTING_PRICE);
  }

  static updateAppraiserPrice({
    id,
    ...data
  }: IUpdatePhotoShootingPriceDTO): ApiResponse<TUpdateAppraiserPriceResponse> {
    const { UPDATE_APPRAISER_PRICE } = getPricesEndpoints({ id });
    return httpClient.post<TUpdateAppraiserPriceResponse>(UPDATE_APPRAISER_PRICE, data);
  }

  static updateSettlementData({ ...data }: IUpdateSettlementDataDTO): ApiResponse<TUpdateSettlementDataResponse> {
    return httpClient.post<TUpdateSettlementDataResponse>(staticPriceEndpoints.UPDATE_SETTLEMENT_PRICE, data);
  }

  static createAppraiserPrice(data: TCreatePhotoShootingPriceDTO): ApiResponse<TUpdateAppraiserPriceResponse> {
    const { CREATE_APPRAISER_PRICES } = staticPriceEndpoints;
    return httpClient.put<TUpdateAppraiserPriceResponse>(CREATE_APPRAISER_PRICES, data);
  }

  static deleteAppraiserPrice(id: string): ApiResponse<TUpdateAppraiserPriceResponse> {
    const { DELETE_APPRAISER_PRICE } = getPricesEndpoints({ id });
    return httpClient.delete<TUpdateAppraiserPriceResponse>(DELETE_APPRAISER_PRICE);
  }
}

export default PricesAPI;
